import React from "react"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { arrayOfColors } from "@Constants/constant"
import { useNavigation, useRoute } from "@react-navigation/native"
import CustomBorderedText from "@Components/CustomBorderedText"

const CustomWorkshopItem = (props) => {
    const { item } = props
    const navigation = useNavigation()
    const colorToUse = arrayOfColors[1]
    const typeColor = arrayOfColors[0]
    const handlePress = () => {
        navigation.navigate("WorkshopDetails", {
            workshopId: item?.workshopId,
            sessionId: item?.sessionId,
            isVisio: item?.isVisio
        })
    }

    return (
        <TouchableOpacity style={styles.container} onPress={handlePress}>
            <OpenSansText
                style={{ color: baseColors.black }}
                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                fontSize={16}
            >
                {item?.name}
            </OpenSansText>

            <OpenSansText
                style={{ color: baseColors.black, marginTop: 10 }}
                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                fontSize={14}
            >
                {item?.description}
            </OpenSansText>

            <View style={{ justifyContent: "flex-end", flexDirection: "row", alignItems: "flex-end" }}>
                <OpenSansText
                    style={{
                        color: baseColors.black
                    }}
                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                    fontSize={14}
                >
                    Prévu le: {item?.startDate}
                </OpenSansText>
            </View>

            <View style={styles.child}>
                {!item.alreadyMember ? (
                    <View style={{ flexDirection: "row" }}>
                        {/* <CustomBorderedText
                            label="S'inscrire à l'atelier"
                            color={colorToUse.textColor}
                            backgroundColor={colorToUse.backgroundColor}
                            fontSize={10}
                        /> */}
                        <CustomBorderedText
                            label={item?.type}
                            color={typeColor.textColor}
                            backgroundColor={typeColor.backgroundColor}
                            fontSize={10}
                        />
                    </View>
                ) : (
                    <View style={{ flexDirection: "row", flex: 1 }}>
                        <CustomBorderedText
                            label="Voir l'atelier"
                            color={colorToUse.textColor}
                            backgroundColor={colorToUse.backgroundColor}
                            fontSize={10}
                        />
                        <CustomBorderedText
                            label={item?.type}
                            color={typeColor.textColor}
                            backgroundColor={typeColor.backgroundColor}
                            fontSize={10}
                        />
                    </View>
                )}
            </View>
        </TouchableOpacity>
    )
}

export default CustomWorkshopItem
